import {
  ENUM_VALUE_TYPE,
  ARRAY_VALUE_TYPE,
  STRING_VALUE_TYPE,
  LABELLED_LAYOUT_TYPE,
  CELL_LAYOUT_TYPE,
  makeUserEditor,
} from 'grb-webui/components/FilterBar';

export default ({ createTimeRangeEditor, authService }) => ({
  emptyChipLabel: 'All batches',
  dialogClassName: 'grb-batch-dialog-filter',
  server: true,
  searchKey: 'search',
  propertyEditors: [
    createTimeRangeEditor({
      title: 'Time range',
      getObjectDate: b => new Date(b.createdAt || 0),
    }),
    {
      title: 'Batch status',
      name: 'status',
      type: ARRAY_VALUE_TYPE,
      useMultipleKeys: true,
      layout: LABELLED_LAYOUT_TYPE,
      namedValues: [
        { value: undefined, label: 'All statuses' },
        { value: 'CREATED', label: 'Created' },
        { value: 'SUBMITTED', label: 'Submitted' },
        { value: 'ABORTED', label: 'Aborted' },
        { value: 'FAILED', label: 'Failed' },
        { value: 'COMPLETED', label: 'Completed' },
      ],
    },
    makeUserEditor({
      name: 'username',
      title: 'Username',
      currentUserChipValue: 'My batches',
      authService,
    }),
    {
      title: 'Batch ID',
      name: 'batchId',
      type: STRING_VALUE_TYPE,
    },
    {
      title: 'Batch limit',
      name: 'length',
      type: ENUM_VALUE_TYPE,
      layout: CELL_LAYOUT_TYPE,
      namedValues: [
        { value: '100', label: '100 batches' },
        { value: '200', label: '200 batches' },
        { value: '500', label: '500 batches' },
      ],
      defaultValue: '200',
    },
    {
      title: 'Discarded',
      name: 'discarded',
      type: ENUM_VALUE_TYPE,
      layout: CELL_LAYOUT_TYPE,
      namedValues: [
        { value: undefined, label: 'All' },
        { value: 'true', label: 'Discarded' },
        { value: 'false', label: 'Not discarded' },
      ],
    },
    {
      title: 'Application',
      name: 'app',
      type: STRING_VALUE_TYPE,
    },
  ],
});
